export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === "production";
export const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === "preview";
export const isStaging =
  isPreview && process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === "staging";
export const isTesting = process.env.NODE_ENV === "test";
export const isLocal = !process.env.NEXT_PUBLIC_VERCEL_ENV;
export const isEvalRun = process.env.IS_EVAL === "1";

export const getEnvironment = () => {
  if (isProduction) return "production";
  if (isStaging) return "staging";
  if (isPreview) return "preview";
  if (isLocal) return "local";
  if (isTesting) return "testing";
  return undefined;
};

// Backend service name for API tracing
export const SERVICE_NAME = "zapiermcp";
// Frontend service name for RUM
export const SERVICE_APP_NAME = "zapiermcp";

export const ALLOWED_TRACING_ORIGINS: (RegExp | string)[] = [
  /https:\/\/(.*\.)?zapier(-staging|-deployment)?\.com/,
];

export const getBaseUrl = () =>
  process.env.NEXTAUTH_URL || "https://mcp.zapier.com";

export const getConnectAppBaseUrl = () =>
  process.env.CONNECT_APP_BASE_URL || "https://connect.zapier.com";
